import React, {useEffect, useRef} from 'react';

export function GalleryStaffDialog({title, children, onClose, busy=false}) {
  const panel=useRef(null),previous=useRef(null);
  useEffect(()=>{
    previous.current=document.activeElement;
    panel.current?.querySelector('button,input,select,textarea')?.focus();
    const bodyOverflow=document.body.style.overflow;
    document.body.style.overflow='hidden';
    return()=>{document.body.style.overflow=bodyOverflow;previous.current?.focus();};
  },[]);
  const keys=event=>{
    if(event.key==='Escape'){event.preventDefault();if(!busy)onClose();}
    if(event.key!=='Tab')return;
    const controls=[...panel.current.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),a[href]')];
    const first=controls[0],last=controls[controls.length-1];
    if(!controls.length){event.preventDefault();return;}
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  };
  return <div className="staff-dialog-overlay"><section ref={panel} role="dialog" aria-modal="true" aria-label={title} aria-busy={busy} onKeyDown={keys} className="staff-dialog"><header className="flex items-start justify-between gap-4"><h2 className="text-2xl font-semibold">{title}</h2><button type="button" className="staff-button" onClick={onClose} disabled={busy} aria-label={'Close '+title}>Close</button></header>{children}</section></div>;
}
